export enum actionTypesContainers {
  ListOfContainers = "containersList",
  IsContainersTableRefreshed = "isContainersTableRefreshed",
  SelectedContainer = "selectedContainer",
}
